<template>
  <div>
    <div
      style="
        position: sticky;
        top: 60px;
        right: 0;
        display: flex;
        justify-content: flex-end;
        margin: 12px 0;
      "
    >
      <button
        id="botaoAdicionar"
        data-test-id="button-botaoadicionar"
        type="button"
        class="btn btn-primary"
        @click="abrirModal"
      >
        <span class="fa fa-plus"></span> Adicionar diário
      </button>
    </div>
    <div>
      <div v-if="items && items.length">
        <div
          v-for="diario in items"
          :key="diario._id"
          style="padding: 2px 8px; margin-bottom: 24px"
        >
          <div
            style="
              display: flex;
              align-items: baseline;
              justify-content: space-between;
              padding-bottom: 5px;
              color: #525252;
              border-bottom: 1px solid #d4d4d4;
              gap: 4px;
            "
          >
            <div style="display: flex; flex-flow: column">
              <strong class="text-primary" style="font-size: 12pt">
                {{
                  dataAgendamento(
                    diario._agendamento ? diario._agendamento.data : diario.data
                  )
                }}
              </strong>
              <span
                >{{ diario.usuario.nome }} {{ dataDiario(diario.data) }}.</span
              >
              <span v-if="diario._agendamento">
                {{ diario._agendamento.especialidade }}
                {{ diario._agendamento.unidade }}
              </span>
              <span v-else> Sessão não informada </span>
            </div>
            <div>
              <button
                data-test-id="button-excluirdiario-2"
                type="button"
                class="btn btn-xs btn-default"
                @click="excluirDiario(diario)"
              >
                <span class="fa fa-trash"></span> Remover
              </button>
              <button
                data-test-id="button-abrirdiario-3"
                type="button"
                class="btn btn-xs btn-default"
                @click="abrirDiario(diario)"
              >
                <span class="fa fa-edit"></span> Editar
              </button>
            </div>
          </div>
          <div style="padding: 12px 8px" v-html="diario.entrada"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    diarios: {
      type: Array,
      default: () => [],
    },
    especialidades: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      const result = [...this.diarios]
      return result.sort((d1, d2) => {
        if (d1._agendamento && d2._agendamento)
          return new Date(d2._agendamento.data) - new Date(d1._agendamento.data)
        else return new Date(d2.data) - new Date(d1.data)
      })
    },
  },
  methods: {
    dataAgendamento(data) {
      return moment.utc(data).startOf('day').format('MMM DD, YYYY')
    },
    dataDiario(data) {
      const dataFormatada = moment
        .utc(data)
        .startOf('day')
        .format('MMM DD, YYYY')
      if (moment.utc(data).startOf('day').isSame(moment.utc().startOf('day')))
        return `hoje (${dataFormatada})`
      return `${moment
        .utc()
        .startOf('day')
        .to(moment.utc(data).startOf('day'))} (${dataFormatada})`
    },
    abrirDiario(diario) {
      this.$emit('selecionar', diario)
      this.abrirModal()
    },
    excluirDiario(diario) {
      this.$emit('remover', diario)
    },
    abrirModal() {
      this.$emit('abrir-modal')
    },
    fecharModal() {
      document.querySelector('#diarioForm').close()
    },
  },
}
</script>
